module.exports = __webpack_public_path__ + "img/introduction_htsk.dbe90091.png";